import LoadingSpinner from "./LoadingSpinner";

function LoadingWrapper(Component) {
    return function WihLoadingComponent({ isLoading, ...props }) {
        if (!isLoading) return <Component {...props} />;
        return <LoadingSpinner />;
    };
}
export default LoadingWrapper;
